import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_EV_DEMO_USE_CASE_1_EXP_VIDEO = {
  videoSrc: "EV/Use_case_1_exp.mp4",
  title: "ORDER MANAGMENT: EXPLAINER VIDEO",
  onClose: () => setCurrentPage(404),
};

export default DATA_EV_DEMO_USE_CASE_1_EXP_VIDEO;
